"use strict";
/* globals window, FormData */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var apisauce_1 = tslib_1.__importDefault(require("apisauce"));
var data_helpers_1 = tslib_1.__importDefault(require("./data-helpers"));
var instances = {};
/**
 * @deprecated, use Scribe service instead and add to it if endpoint does not exist there
 * @param authToken
 * @param baseURL
 */
var create = function (authToken, baseURL) {
    if (typeof authToken !== 'string')
        throw new Error('Scribe.create() requires an authToken as the first parameter');
    var instanceId = authToken + baseURL;
    if (typeof instances[instanceId] !== 'undefined')
        return instances[instanceId];
    var api = apisauce_1.default.create({
        baseURL: baseURL,
        headers: {
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            Authorization: "Bearer ".concat(authToken)
        },
        timeout: 20000
    });
    // URL Builders
    var buildGetUser = function (userId) { return "/users/".concat(userId); };
    var buildGetCreditCard = function (userId) {
        return "/users/".concat(userId, "?include=active_credit_card");
    };
    var buildRegisterCardUrl = function (userId) {
        return "/users/".concat(userId, "/stripe_registrations");
    };
    var buildChargeCardUrl = function (chargeId) { return "/charges/".concat(chargeId, "/capture"); };
    var buildFamilyMembersUrl = function (userId) { return "/users/".concat(userId, "/family_members"); };
    var buildFamilyMemberUrl = function (familyId, memberId) {
        return "/families/".concat(familyId, "/members/").concat(memberId);
    };
    var buildChildUrl = function (userId) { return "/users/".concat(userId, "/children"); };
    var normalizeFamilyMember = function (rawFamilyMember) { return ({
        id: rawFamilyMember.id,
        email: rawFamilyMember.attributes.email,
        givenName: rawFamilyMember.attributes.first_name,
        familyName: rawFamilyMember.attributes.last_name,
        birthdate: rawFamilyMember.attributes.birthdate,
        picture: rawFamilyMember.attributes.picture,
        sex: rawFamilyMember.attributes.sex,
        type: rawFamilyMember.attributes.type,
        status: rawFamilyMember.attributes.status,
        healthcardUrl: rawFamilyMember.links &&
            rawFamilyMember.links.healthcard &&
            rawFamilyMember.links.healthcard.href,
        permissions: rawFamilyMember.links &&
            rawFamilyMember.links.self &&
            rawFamilyMember.links.self.meta &&
            rawFamilyMember.links.self.meta.methods &&
            (rawFamilyMember.links.self.meta.methods.includes('delete') // usually for invited members
                ? 'delete'
                : rawFamilyMember.links.self.meta.methods.includes('put') // usually only for children
                    ? 'put'
                    : 'none')
    }); };
    // Transforms
    var normalizeFamily = function (rawFamily) {
        return rawFamily.map(function (member) { return normalizeFamilyMember(member); });
    };
    var normalizeFamilyId = function (relationships) {
        return relationships.family &&
            relationships.family.data &&
            relationships.family.data.id;
    };
    var normalizeFamilyPermissions = function (links) { return ({
        children: links &&
            links.children &&
            links.children.meta &&
            links.children.meta.methods &&
            links.children.meta.methods.includes('post')
            ? 'create'
            : 'read',
        dependents: links &&
            links.dependents &&
            links.dependents.meta &&
            links.dependents.meta.methods &&
            links.dependents.meta.methods.includes('post')
            ? 'create'
            : 'read'
    }); };
    // API
    var getUser = function (userId, params) {
        return api.get(buildGetUser(userId), params).then(function (response) {
            if (response.ok) {
                return response.data;
            }
            else {
                throw response.data;
            }
        });
    };
    var getCreditCard = function (userId) {
        return api.get(buildGetCreditCard(userId)).then(function (response) {
            if (response.ok) {
                if (response.data.included) {
                    if (response.data.included.length > 0) {
                        return response.data.included[0].attributes;
                    }
                    else {
                        return null;
                    }
                }
                else {
                    throw response.data.errors[0] || {
                        status: response.status,
                        title: 'Incomplete response body',
                        detail: 'Missing "included" key in response body'
                    };
                }
            }
            else {
                throw response.data.errors[0] || {
                    status: response.status,
                    title: 'Empty error body',
                    detail: 'none'
                };
            }
        });
    };
    var registerCreditCard = function (userId, creditCardToken) {
        return api
            .post(buildRegisterCardUrl(userId), {
            data: {
                type: 'stripe_registration',
                attributes: {
                    token: creditCardToken
                }
            }
        })
            .then(function (response) {
            if (response.ok) {
                if (response.data.data && response.data.data.attributes) {
                    return response.data.data.attributes;
                }
                else {
                    throw response.data.errors[0] || {
                        status: response.status,
                        title: 'Incomplete response body',
                        detail: 'Missing "attributes" key in response body'
                    };
                }
            }
            else {
                throw response.data.errors[0] || {
                    status: response.status,
                    title: 'Empty error body',
                    detail: 'none'
                };
            }
        });
    };
    var chargeCreditCard = function (chargeId) {
        return api.post(buildChargeCardUrl(chargeId)).then(function (response) {
            if (response.ok) {
                return response.data.data;
            }
            else {
                throw response.data.errors[0] || {
                    status: response.status,
                    title: 'Empty error body',
                    detail: 'none'
                };
            }
        });
    };
    var getFamilyMembers = function (userId) {
        return api.get(buildFamilyMembersUrl(userId)).then(function (response) {
            if (response.ok) {
                if (response.data) {
                    var data = response.data;
                    var familyId = normalizeFamilyId(data.relationships);
                    var family = normalizeFamily(data.data);
                    var permissions = normalizeFamilyPermissions(data.links);
                    return {
                        familyId: familyId,
                        family: family,
                        permissions: permissions
                    };
                }
            }
            throw response.data.errors[0] || {
                status: response.status,
                title: 'Empty error body',
                detail: 'none'
            };
        });
    };
    var addAdult = function (userId, emailToInvite) {
        return api
            .post(buildFamilyMembersUrl(userId), {
            data: {
                type: 'family_member',
                attributes: {
                    email: emailToInvite,
                    type: 'guardian'
                }
            }
        })
            .then(function (response) {
            if (response.ok && response.data && response.data.data) {
                var data = response.data.data;
                return {
                    member: normalizeFamilyMember(data),
                    familyId: normalizeFamilyId(data.relationships)
                };
            }
            throw response.data.errors[0] || {
                status: response.status,
                title: 'Empty error body',
                detail: 'none'
            };
        });
    };
    var removeAdult = function (familyId, memberId) {
        return api
            .delete(buildFamilyMemberUrl(familyId, memberId))
            .then(function (response) {
            if (response.ok) {
                if (response.data)
                    return response.data.data;
            }
            throw response.data.errors[0] || {
                status: response.status,
                title: 'Empty error body',
                detail: 'none'
            };
        });
    };
    var addChild = function (userId, child) {
        var givenName = child.givenName, familyName = child.familyName, dateOfBirth = child.dateOfBirth, sex = child.sex;
        return api
            .post(buildChildUrl(userId), {
            data: {
                type: 'child',
                attributes: {
                    first_name: givenName,
                    last_name: familyName,
                    birthdate: dateOfBirth,
                    sex: sex
                }
            }
        })
            .then(function (response) {
            if (response.ok) {
                if (response.data) {
                    if (response.data.data &&
                        response.data.data.attributes &&
                        response.data.data.links) {
                        return {
                            child: normalizeFamilyMember(response.data.data),
                            url: response.data.data.links.healthcard.meta.post_info.url,
                            fields: response.data.data.links.healthcard.meta.post_info.fields
                        };
                    }
                }
            }
            throw response.data.errors[0] || {
                status: response.status,
                title: 'Empty error body',
                detail: 'none'
            };
        });
    };
    // Note: This is unfortunately not the same code path as updating a user's id.
    // We should probably consolidate this code replication
    var uploadChildIdCard = function (url, fields, path) {
        var body = new FormData();
        Object.keys(fields).forEach(function (key) {
            body.append(key, fields[key]);
        });
        var file = data_helpers_1.default.pathToFile(path);
        body.append('file', file);
        var aws = apisauce_1.default.create({
            baseURL: url,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            timeout: 20000
        });
        return aws.post(url, body).then(function (response) {
            if (response.ok)
                return response;
            throw response.data.errors[0] || {
                status: response.status,
                title: 'Empty error body',
                detail: 'none'
            };
        });
    };
    var updateChild = function (familyId, memberId, child) {
        var givenName = child.givenName, familyName = child.familyName, dateOfBirth = child.dateOfBirth, sex = child.sex;
        return api
            .patch(buildFamilyMemberUrl(familyId, memberId), {
            data: {
                type: 'child',
                attributes: {
                    first_name: givenName,
                    last_name: familyName,
                    birthdate: dateOfBirth,
                    sex: sex
                }
            }
        })
            .then(function (response) {
            if (response.ok) {
                if (response.data) {
                    if (response.data.data &&
                        response.data.data.attributes &&
                        response.data.data.links) {
                        return {
                            child: normalizeFamilyMember(response.data.data),
                            url: response.data.data.links.healthcard.meta.post_info.url,
                            fields: response.data.data.links.healthcard.meta.post_info.fields
                        };
                    }
                }
            }
            throw response.data.errors[0] || {
                status: response.status,
                title: 'Empty error body',
                detail: 'none'
            };
        });
    };
    instances[instanceId] = {
        getUser: getUser,
        addAdult: addAdult,
        addChild: addChild,
        chargeCreditCard: chargeCreditCard,
        getCreditCard: getCreditCard,
        getFamilyMembers: getFamilyMembers,
        registerCreditCard: registerCreditCard,
        removeAdult: removeAdult,
        updateChild: updateChild,
        uploadChildIdCard: uploadChildIdCard
    };
    return instances[instanceId];
};
exports.default = {
    create: create
};
